import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title: string;
    description: string;
    canonical?: string;
    image?: string;
    type?: 'website' | 'article' | 'job' | 'profile';
    schema?: Record<string, any>;
    keywords?: string[];
}

export const SEO: React.FC<SEOProps> = ({
    title,
    description,
    canonical,
    image = '/logo.png',
    type = 'website',
    schema,
    keywords = []
}) => {
    const siteTitle = 'MegaJobNepal';
    const fullTitle = title === siteTitle ? title : `${title} | ${siteTitle}`;
    const currentUrl = canonical || (typeof window !== 'undefined' ? window.location.href : '');

    // Default keywords if none provided
    const defaultKeywords = ['jobs in nepal', 'job portal nepal', 'career in nepal', 'vacancies nepal', 'mega job nepal'];
    const allKeywords = [...keywords, ...defaultKeywords].join(', ');

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={allKeywords} />
            <link rel="canonical" href={currentUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={currentUrl} />
            <meta property="og:image" content={image} />
            <meta property="og:site_name" content={siteTitle} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Structured Data (JSON-LD) */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};
